import { createSelector } from '@ngrx/store';
import { selectState } from '../../config/selectors';
import { ModuleState } from '../reducers/module.reducer';

const selectModuleState = createSelector(selectState, (state) => state.module);

export const selectLoaded = (id: string) => createSelector(selectModuleState, (state: ModuleState) => (state.items[id] ? state.items[id].loaded : null));
export const selectLoading = (id: string) => createSelector(selectModuleState, (state: ModuleState) => (state.items[id] ? state.items[id].loading : false));
export const selectModule = (id: string) => createSelector(selectModuleState, (state: ModuleState) => (state.items[id] ? state.items[id].data : null));
